/** Tipos de anexo permitidos em tickets de qualidade (imagens + e-mail Outlook + PDF). */

export const TICKET_ATTACHMENT_ACCEPT =

  'image/*,.msg,.eml,.pdf,application/vnd.ms-outlook,message/rfc822,application/pdf'



/** Limite máximo por arquivo (20 MB). */
export const TICKET_ATTACHMENT_MAX_BYTES = 20 * 1024 * 1024
export const TICKET_ATTACHMENT_MAX_MB = 20



const IMAGE_EXT = /\.(jpe?g|png|gif|webp|bmp|svg)$/i

const EMAIL_EXT = /\.(msg|eml)$/i

const PDF_EXT = /\.pdf$/i



export function isTicketAttachmentImage(att: {

  file_name?: string

  mime_type?: string | null

}): boolean {

  if (att.mime_type?.startsWith('image/')) return true

  return IMAGE_EXT.test(att.file_name ?? '')

}



export function isTicketAttachmentEmail(att: {

  file_name?: string

  mime_type?: string | null

}): boolean {

  const mime = att.mime_type?.toLowerCase()

  if (

    mime === 'application/vnd.ms-outlook' ||

    mime === 'message/rfc822' ||

    mime === 'application/vnd.ms-office'

  ) {

    return true

  }

  return EMAIL_EXT.test(att.file_name ?? '')

}



export function isTicketAttachmentPdf(att: {

  file_name?: string

  mime_type?: string | null

}): boolean {

  if (att.mime_type?.toLowerCase() === 'application/pdf') return true

  return PDF_EXT.test(att.file_name ?? '')

}



export function isAllowedTicketAttachmentFile(file: File): boolean {
  if (file.type.startsWith('image/')) return true
  if (file.type === 'application/pdf') return true
  const ext = file.name.split('.').pop()?.toLowerCase()
  return ext === 'msg' || ext === 'eml' || ext === 'pdf'
}

export function isTicketAttachmentWithinSizeLimit(file: File): boolean {
  return file.size <= TICKET_ATTACHMENT_MAX_BYTES
}



/** MIME para upload quando o navegador não informa (comum em .msg). */

export function guessTicketAttachmentMimeType(fileName: string, browserType?: string): string {

  if (browserType) return browserType

  const ext = fileName.split('.').pop()?.toLowerCase()

  if (ext === 'msg') return 'application/vnd.ms-outlook'

  if (ext === 'eml') return 'message/rfc822'

  if (ext === 'pdf') return 'application/pdf'

  return 'application/octet-stream'

}



export function formatTicketAttachmentSize(bytes?: number | null): string {

  if (bytes == null) return ''

  if (bytes < 1024) return `${bytes} B`

  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`

  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`

}

